import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import LazyImage from '../components/LazyImage';
import CustomDot from './CustomDots';
import { MediaType, ProductMedia } from '../interface/interface';
import { Dispatch, SetStateAction } from 'react';

export default function ProductCarousel({
  media,
  setImageUrl,
  setOpen,
}: Readonly<{
  media: ProductMedia[];
  setImageUrl: Dispatch<SetStateAction<string>>;
  setOpen: Dispatch<SetStateAction<boolean>>;
}>) {
  return (
    <Carousel
      additionalTransfrom={0}
      arrows={true}
      autoPlaySpeed={3000}
      centerMode={false}
      containerClass="container"
      renderArrowsWhenDisabled={false}
      renderButtonGroupOutside={false}
      responsive={{
        desktop: {
          breakpoint: {
            max: 3000,
            min: 1024,
          },
          items: 1,
        },
        mobile: {
          breakpoint: {
            max: 464,
            min: 0,
          },
          items: 1,
        },
        tablet: {
          breakpoint: {
            max: 1024,
            min: 464,
          },
          items: 1,
        },
      }}
      showDots={true}
      customDot={<CustomDot urls={media.map((x) => x.thumbnail)} />}
    >
      {media.map((m: ProductMedia, i: number) => {
        if (m.type === MediaType.IMAGE) {
          return (
            <LazyImage
              key={i + ''}
              url={m.url}
              alt="product_image"
              className="w-8/12 h-96 object-contain mx-auto"
              setOpen={setOpen}
              setImageUrl={setImageUrl}
            />
          );
        }

        return (
          <div
            key={i + 1}
            className="h-[500px] w-[500px] mx-auto flex justify-center items-center"
          >
            <video controls poster={m.thumbnail} className="">
              <source src={m.url} type="video/mp4" />
              <track
                src="captions.vtt"
                kind="subtitles"
                srcLang="en"
                label="English"
                default
              />
            </video>
          </div>
        );
      })}
    </Carousel>
  );
}
